/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_ContextInputs */



/**
* | output |
* | --- |
* | "User Context" |
*
* @param {User_ContextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const user_context = /** @type {((inputs?: User_ContextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_ContextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contexte utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerkontext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contesto utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контекст пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contexto del usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户上下文")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーコンテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता संदर्भ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contexto do usuário")
	return /** @type {LocalizedString} */ ("User Context")
});